module.exports = __webpack_public_path__ + "static/img/homePage1.d44377e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme-img/homePage1.png
// module id = 9XYD
// module chunks = 202